import React from 'react'
import { useNavigate } from 'react-router-dom'
import { 
  HomeOutlined, 
  LineChartOutlined, 
  DollarOutlined, 
  UserOutlined
} from '@ant-design/icons'
import { useLanguage } from '../../contexts/LanguageContext'
import { DEFAULT_TRADE_DISPLAY_SYMBOL } from '../../config/futuresDisplay'

interface MobileNavigationProps {
  currentPath: string
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ currentPath }) => {
  const navigate = useNavigate()
  const { t } = useLanguage()

  const tradePath = `/trade/${DEFAULT_TRADE_DISPLAY_SYMBOL}`

  const navItems = [
    {
      key: '/home',
      icon: HomeOutlined,
      label: t('navigation.home'),
    },
    {
      key: '/market',
      icon: LineChartOutlined,
      label: t('navigation.market'),
    },
    {
      key: tradePath,
      icon: DollarOutlined,
      label: t('navigation.trade'),
    },
    {
      key: '/mine',
      icon: UserOutlined,
      label: t('navigation.mine'),
    },
  ]

  const handleNavClick = (path: string) => {
    navigate(path)
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-700 z-50">
      <div className="flex">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = currentPath === item.key || 
            (item.key === '/mine' && currentPath === '/mine') ||
            (item.key === tradePath && (currentPath.startsWith('/trade') || currentPath.startsWith('/spot-trading') || currentPath.startsWith('/margin-trading') || currentPath.startsWith('/seconds-trading'))) ||
            (item.key === '/market' && currentPath.startsWith('/market')) ||
            (item.key === '/home' && currentPath === '/home')
          
          return (
            <button
              key={item.key}
              onClick={() => handleNavClick(item.key)}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                isActive 
                  ? 'text-yellow-500' 
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              <Icon className="text-xl mb-1" />
              <span className="text-xs">{item.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default MobileNavigation